<template>
  <div>
    <b-form-radio-group :checked="subType" @change="updateType($event)">
      <b-form-radio  value="date" :data-test="`demo-suppression-box-date-${suppressionType}`">By Date Range</b-form-radio>
      <b-form-radio  value="item" :data-test="`demo-suppression-box-item-${suppressionType}`">By Selected Order(s)</b-form-radio>
    </b-form-radio-group>
    <div v-if="subType==='date'">
      Start Date
      <datepicker v-model="startDate" format="MM/dd/yyyy"></datepicker>
      End Date
      <datepicker v-model="endDate" :disabled="endDateDisabled" format="MM/dd/yyyy"></datepicker><br>
    </div>
    <m-suppression-select-item v-if="subType==='item'" :configData="configeData" :suppressions="suppressionItems" />

  </div>

</template>

<script>
  import Datepicker from 'vuejs-datepicker'
  import MSuppressionSelectItem from '@/components/demo/MSuppressionSelectItem'
  // import utils from '@/assets/utils'

  export default {
    components: {
      MSuppressionSelectItem,
      Datepicker
    },
    props: {
      suppressionType: {
        type: String,
        default: 'order' // slc, file
      },
      subType: {
        type: [Boolean, String],
        default: false
      },
      itemTitle: {
        type: String,
        default: 'By Selected Item'
      }
    },
    created () {
      // this.$emit('updateType', this.type)
    },
    data () {
      return {
        type: 'date', // date, item
        startDateDisabled: {
          to: new Date()
        },
        configDatas: {
          order: {
            type: 'order',
            itemTitle: 'Your Order List',
            selectedTitle: 'Prior Orders to Suppress',
            getItemUrl: 'PlaceOrder.aspx/GetSuppressionList',
            addItemKey: 'order/addOrderSuppressions',
            removeItemKey: 'order/removeOrderSuppressions',
            clearItemsKey: 'OrderSuppressions',
            searchText1: 'Order Name',
            searchText2: 'Order Number',
            isShowAddAll: true,
            itemTitle1: 'Order Date',
            itemTitle2: 'Order Code',
            itemTitle3: 'Order Name',
            itemTitle4: 'Quantity',
            selectItemTitle1: 'Order Code',
            selectItemTitle2: 'Order Name',
            filterAdded: 'OrderCode'
          },
          slc: {
            type: 'slc',
            itemTitle: 'Your Saved Count List Count(s)',
            selectedTitle: 'Saved Counts to Suppress',
            getItemUrl: 'PlaceOrder.aspx/GetSaveCountSuppressionList',
            addItemKey: 'order/addSaveCountSuppressions',
            removeItemKey: 'order/removeSaveCountSuppressions',
            clearItemsKey: 'SaveCountSuppressions',
            searchText1: 'Count Name',
            searchText2: 'Count Number',
            isShowAddAll: true,
            itemTitle1: 'Count Date',
            itemTitle2: 'Count ID',
            itemTitle3: 'Count Name',
            itemTitle4: 'Quantity',
            selectItemTitle1: 'Count ID',
            selectItemTitle2: 'Count Name',
            filterAdded: 'OrderCode'
          },
          file: {
            type: 'file',
            itemTitle: 'Your Custom Order List',
            selectedTitle: 'Uploaded Files to Suppress',
            getItemUrl: 'PlaceOrder.aspx/GetCustomSuppressions',
            addItemKey: 'order/addCustomSuppressions',
            removeItemKey: 'order/removeCustomSuppressions',
            clearItemsKey: 'OrderSuppressions',
            searchText1: 'Order Name',
            searchText2: 'Order Number',
            isShowAddAll: true,
            itemTitle1: 'File Date',
            itemTitle2: 'File Name',
            selectItemTitle1: 'Order Date',
            selectItemTitle2: 'File Name',
            filterAdded: 'SuppressionValue',
            isFile: true
          }
        }
      }
    },
    watch: {
      type (val) {
        this.$emit('updateType', val)
      }
    },
    computed: {
      startDate: {
        get () {
          if (this.subType !== 'date') {
            return null
          }
          let date = null
          if (this.suppressionType === 'order') {
            date = this.$store.state.order.SuppressionStartDate
          } else if (this.suppressionType === 'slc') {
            date = this.$store.state.order.SaveCountSuppressionStartDate
          } else {
            date = this.$store.state.order.CustomSuppressionStartDate
          }
          if (!date) {
            date = new Date(new Date() - 7 * 86400000)
            let key = 'SuppressionStartDate'
            if (this.suppressionType === 'slc') {
              key = 'SaveCountSuppressionStartDate'
            } else if (this.suppressionType === 'file') {
              key = 'CustomSuppressionStartDate'
            }
            this.$store.commit('order/saveKey', [key, date])
          }
          return date
        },
        set (val) {
          if (val === this.startDate) {
            return false
          }
          let key = 'SuppressionStartDate'
          if (this.suppressionType === 'slc') {
            key = 'SaveCountSuppressionStartDate'
          } else if (this.suppressionType === 'file') {
            key = 'CustomSuppressionStartDate'
          }
          this.$store.commit('order/saveKey', [key, val])
        }
      },
      endDate: {
        get () {
          if (this.subType !== 'date') {
            return null
          }
          let date = null
          if (this.suppressionType === 'order') {
            date = this.$store.state.order.SuppressionEndDate
          } else if (this.suppressionType === 'slc') {
            date = this.$store.state.order.SaveCountSuppressionEndDate
          } else {
            date = this.$store.state.order.CustomSuppressionEndDate
          }
          if (!date) {
            date = new Date()
            let key = 'SuppressionEndDate'
            if (this.suppressionType === 'slc') {
              key = 'SaveCountSuppressionEndDate'
            } else if (this.suppressionType === 'file') {
              key = 'CustomSuppressionEndDate'
            }
            this.$store.commit('order/saveKey', [key, date])
          }
          return date
        },
        set (val) {
          if (val === this.endtDate) {
            return false
          }
          let key = 'SuppressionEndDate'
          if (this.suppressionType === 'slc') {
            key = 'SaveCountSuppressionEndDate'
          } else if (this.suppressionType === 'file') {
            key = 'CustomSuppressionEndDate'
          }
          this.$store.commit('order/saveKey', [key, val])
        }
      },
      endDateDisabled () {
        return {
          from: new Date(),
          to: this.startDate
        }
      },
      listType () {
        return this.$store.state.order.ListType
      },
      orderSuppressions () {
        return this.$store.state.order.OrderSuppressions || []
      },
      savCountSuppressions () {
        return this.$store.state.order.SaveCountSuppressions || []
      },
      customSuppressions () {
        return this.$store.state.order.CustomSuppressions || []
      },
      suppressionItems () {
        let result = []
        if (this.suppressionType === 'order') {
          for (let item of this.orderSuppressions) {
            result.push({
              name: item.SuppressionName,
              code: item.SuppressedOrderCode,
              value: item.SuppressionValue
            })
          }
        } else if (this.suppressionType === 'slc') {
          for (let item of this.savCountSuppressions) {
            result.push({
              name: item.SuppressionName,
              code: item.SuppressedCountCode,
              value: item.SuppressionValue
            })
          }
        } else {
          for (let item of this.customSuppressions) {
            result.push({
              code: item.OrderDate,
              name: item.FileName,
              value: item.SuppressionValue,
              SuppressionDesc: item.SuppressionDesc,
              OrderDate: item.OrderDate,
              SuppressionName: item.SuppressionName,
              SuppressionValue: item.SuppressionValue
            })
          }
        }
        return result
      },
      configeData () {
        return this.configDatas[this.suppressionType]
      }
    },
    methods: {
      updateType (val) {
        this.$emit('updateType', val)
      }
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/demo/MsuppressionItem.vue